import { Resources } from "Infrastructure/Translation/Resources";
import type { TOptions } from "i18next";
import type { ObjPathProxy } from "ts-object-path";
import { z } from "zod";

const validationMessagesResource = Resources.base.market.validationMessages;

export const getRegionsFormSchema = (
	t: (
		resourcePath: ObjPathProxy<unknown, string>,
		options?: TOptions,
	) => string,
) => {
	return z.object({
		regions: z.array(
			z.object({
				name: z.string().nonempty({
					message: t(validationMessagesResource.regionName),
				}),
				regionCode: z
					.string()
					.trim()
					.max(10)
					.nonempty({
						message: t(validationMessagesResource.regionCode),
					}),
			}),
		),
	});
};

export type RegionsFormSchema = z.infer<
	ReturnType<typeof getRegionsFormSchema>
>;
